
import Input from "../Input";
import Output from "../Output";

import switchImage from "../../assets/switch.png";
import { Helmet } from 'react-helmet-async';
import { Link } from "react-router-dom";

import szerb from "../../assets/szerb.png"
import magyar from "../../assets/magyar.png"
import arrow from "../../assets/arrow.png"

function MagyarSzerb({ handleText, output, handleTarget, handleSource, langs, handleSwap, handleTranslate, text }) {


    return (

        <>
            <Helmet>
                <title>Magyar szerb fordító</title>
                <meta name='description' content="Ingyenes magyar szerb fordító szavakra, kifejezésekre, mondatokra. Akár teljes szöveg fordítása is." />
                <meta title="Magyar szerb fordító" />
                <link rel="canonical" href="https://online-fordito.hu/magyar-szerb-fordito" />
            </Helmet>
            <h1>Magyar szerb fordító</h1>
            <div className="wrapper">
                <div>
                    <Input handleText={handleText} handleSource={handleSource} langs={langs} text={text}></Input>
                    <button className="transbutton" onClick={handleTranslate}>Fordítás</button>
                </div>

                <button className="switch" onClick={handleSwap}><img src={switchImage}></img></button>


                <Output output={output} handleTarget={handleTarget} langs={langs} />

            </div>

            <section>


                <div className="sectionhead">
                    <h2>A magyar és szerb nyelv </h2>
                    <img src={magyar} alt="magyar zászló"></img>
                    <img src={szerb} alt="szerb zászló"></img>
                </div>


                <p>A magyar és a szerb nyelv két különböző nyelv, bár közel helyezkednek el egymáshoz, és vannak bizonyos hasonlóságok közöttük. Az alábbiakban bemutatok néhány különbséget és hasonlóságot a két nyelv között:</p>

                <h3>Hasonlóságok</h3>
                <ul>
                    <li><b>Hangrendszer</b>: Mind a magyar, mind a szerb nyelv rendelkezik hangrendszerekkel. Mindkét nyelvben megkülönböztetjük a magas és mély hangrendeket.</li>

                    <li><b>Ragozás</b>: A magyar és a szerb nyelv gazdag ragozású nyelvek. Mindkét nyelvben a szavaknak többféle alakja van a különböző esetekben, számokban vagy névmódokban.</li>

                    <li><b>Szórend</b>: Általában mind a magyar, mind a szerb nyelvben az alany-állítmány-tárgy (AAT) szórend a leggyakoribb, bár mindkét nyelvben lehetnek eltérések és kivételek.</li>

                    <li><b>Közeli földrajzi és kulturális kapcsolatok</b>: Magyarország és Szerbia szomszédos országok, és a történelmi kapcsolatok miatt vannak közös történelmi, kulturális és gazdasági elemek is a két nyelv között.</li>
                </ul>


                <h3>Különbségek</h3>
                <ul>
                    <li><b>Nyelvcsalád és rokonság</b>: A magyar ugor-altaikus nyelvcsaládba tartozik, míg a szerb indoeurópai nyelvcsaládba, a délszláv nyelvek csoportjába. Ez azt jelenti, hogy a két nyelvnek eltérő eredete és nyelvtörténete van.</li>

                    <li><b>Hangzások és kiejtés</b>: A magyar és a szerb nyelvnek eltérő hangzásai és fonetikai rendszerei vannak. Az egyes hangok és a kiejtési szabályok is különböznek a két nyelvben.</li>

                    <li><b>Nyelvtani struktúra</b>: A magyar és a szerb nyelv nyelvtani struktúrája is eltérő. A szerb nyelvben más jelzőragok, névmások és igék használata lehet, mint a magyar nyelvben.</li>

                    <li><b>Írásrendszer</b>: A magyar nyelv latin betűs írásrendszert használ, míg a szerb nyelvben cirill betűket is használnak, bár az utóbbi időben egyre inkább elterjedt a latin betűs írás is.</li>
                </ul>


                <div className="sectionbottom">
                    <Link to="/szerb-magyar-fordito">Szerb magyar fordító</Link>
                    <img src={szerb} alt="szerb zászló"></img>
                    <img src={arrow} alt=">"></img>
                    <img src={magyar} alt="magyar zászló"></img>
                </div>
            </section>
        </>

    )
}

export default MagyarSzerb;